import * as tslib_1 from "tslib";
import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
var styles = require('./OptionsFull.scss');
var OptionsForm = /** @class */ (function (_super) {
    tslib_1.__extends(OptionsForm, _super);
    function OptionsForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OptionsForm.prototype.render = function () {
        var option = this.props.option;
        var fullOptionFormSettings = option.fullOptionFormSettings, key = option.key, titleStringKey = option.titleStringKey, hideTitleInFullOptions = option.hideTitleInFullOptions;
        if (!fullOptionFormSettings) {
            return null;
        }
        var optionAriaId = "options-full-" + key;
        return (React.createElement("div", { className: styles.optionEntry },
            !hideTitleInFullOptions && (React.createElement("div", { className: styles.header, role: "heading", "aria-level": 4 },
                React.createElement("span", { className: styles.title, id: optionAriaId }, strings[titleStringKey]))),
            React.createElement("div", { className: styles.formContainer, "aria-labelledby": optionAriaId }, fullOptionFormSettings.render())));
    };
    OptionsForm = tslib_1.__decorate([
        observer
    ], OptionsForm);
    return OptionsForm;
}(React.Component));
export default OptionsForm;
//# sourceMappingURL=OptionsForm.js.map